module.exports = __webpack_public_path__ + "static/media/file-minus.57b1b04f.svg";